/**
 * 네이티브 햅틱 아이콘 — 시안 `Icon / Native Haptics`(`Icons/haptic-point-24px` 계열, TrustBadges 시안 B · 2026-10-29 확정).
 *
 * ⚠️ 손으로 근사하지 말 것 — Figma node `31824:39742` 에서 추출한 path 다(20×20 박스 그대로).
 * 색은 `currentColor` — 원본은 `#4D5358`(coolgray-70) 하드코딩, 호출처(`TrustBadges` `ICON`)가 같은 색을 준다.
 */
export default function NativeHapticsIcon(
  props: React.SVGProps<SVGSVGElement>,
) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
      {...props}
    >
      <path
        d="M11.75 10C11.75 10.9667 10.9667 11.75 10 11.75C9.03333 11.75 8.25 10.9667 8.25 10C8.25 9.03333 9.03333 8.25 10 8.25C10.9667 8.25 11.75 9.03333 11.75 10Z"
        fill="currentColor"
      />
      <path
        d="M13.75 10C13.75 7.92934 12.0707 6.25 10 6.25C7.92934 6.25 6.25 7.92934 6.25 10C6.25 12.0707 7.92934 13.75 10 13.75C12.0707 13.75 13.75 12.0707 13.75 10ZM15 10C15 12.761 12.761 15 10 15C7.23899 15 5 12.761 5 10C5 7.23899 7.23899 5 10 5C12.761 5 15 7.23899 15 10Z"
        fill="currentColor"
      />
      <path
        d="M15.3609 5.01848C15.6329 4.80606 16.0257 4.85407 16.2382 5.1259C18.4756 7.9903 18.4756 12.0092 16.2382 14.8736C16.0257 15.1457 15.6329 15.1943 15.3609 14.9819C15.0889 14.7694 15.041 14.3766 15.2535 14.1046C17.1377 11.6924 17.1375 8.30799 15.2535 5.89576C15.0411 5.62381 15.0891 5.23101 15.3609 5.01848Z"
        fill="currentColor"
      />
      <path
        d="M3.7616 5.1259C3.97411 4.85398 4.36689 4.80603 4.63888 5.01848C4.91081 5.23096 4.95951 5.62376 4.74712 5.89576C2.86288 8.308 2.86288 11.6923 4.74712 14.1046C4.95934 14.3766 4.91081 14.7695 4.63888 14.9819C4.36686 15.1943 3.97406 15.1456 3.7616 14.8736C1.52431 12.0092 1.52421 7.99027 3.7616 5.1259Z"
        fill="currentColor"
      />
    </svg>
  );
}
